class ContratoTabsController
  @$inject = ['pathService']

  constructor: (pathService) ->
    url = pathService.getViewUrl() + 'eficiencia-fiscal/view/contrato/'

    @tabsView = [
      {
        id: 'contratos'
        label: 'Empresas'
        url: url + 'contratos.html'
      }
    ]


angular.module('eficienciaFiscalModule').controller('contratoTabsController', ContratoTabsController)